module.exports = __webpack_public_path__ + "static/img/wood51.20dc5b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wood51.jpg
// module id = +Uk3
// module chunks = 0